export function loadLeanDataBookIt(
  windowRef,
  documentRef,
  fileLocation,
  functionName
) {
  windowRef['LeanDataCalendaringObjName'] = functionName
  windowRef[functionName] = (...args) => {
    windowRef[functionName].variables = args
  }
  const scriptElement = documentRef.createElement('script')
  const targetScript = document.getElementsByTagName('script')[0]
  const targetHead = document.getElementsByTagName('head')[0]
  scriptElement.async = 1
  scriptElement.src = fileLocation
  if (targetScript) {
    targetScript.parentNode.insertBefore(scriptElement, targetScript)
  } else if (targetHead) {
    targetHead.append(scriptElement)
  }
}

export function submitHandlerRegister(fName, formId) {
  // in this case, we cannot guarantee the form exists yet since it could be being generated by the hubspot in the page
  // we need make sure the form exists by querying with each formID and only process ones that exist
  console.log('registering... hs form(s) submit handler')

  const forms = document.querySelectorAll(`form.hs-form-${formId}`)

  if (
    window['LDCalendaring'] &&
    window['LDCalendaring'][fName] &&
    forms &&
    forms.length > 0
  ) {
    forms.forEach((form) => {
      // this should only find 1 form, but there might be 2 or more, perform this for all forms
      window['LDCalendaring'][fName](form)
    })
    console.log('registered for form id', formId)
    formId = ''
  }
  // if we weren't able to register the form the first time, try again until its been registered
  if (formId) {
    setTimeout(() => {
      submitHandlerRegister(fName, formId)
    }, 1000)
  }
}
